import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import detector from 'i18next-browser-languagedetector'
import en from './locales/en'
import ru from './locales/ru'
import cn from './locales/cn'

const resources = {
    en: { translation: en },
    ru: { translation: ru },
    cn: { translation: cn }
}

i18n.use(detector)
    .use(initReactI18next)
    .init({
        resources,
        detection: {
            order: ['path'],
            caches: []
        },
        fallbackLng: 'ru',
        debug: false,
        interpolation: {
            escapeValue: false
        }
    })

export default i18n
